import "./infographic-item.scss";
import { sizeImageSrc } from "../../../config/infographic-size.config";
import TRASH_ICON from "../../../assets/images/trash.svg";
import TRASH_DISABLED_ICON from "../../../assets/images/trash-disabled.svg";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import InfographicService from "../../../services/infographic.service";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import InfographicPreviewModal from "../../../modal/infographic-preview/infographic-preview";
import { downloadFile } from "../../../utility/download-file.utility";
import { saveAs } from 'file-saver';
import { useSnackbar } from "../../../utility/snackbar.utility";
import CustomSnackbar from "../../snackbar/snackbar.component";
import ConfirmModal from "../../../modal/confirm/confirm.component";

const InfographicItemComponent = ({ mediaId, no, item, isArchived, onDelete }) => {

    const navigate = useNavigate();
    const { snackbar, showSnackbar, hideSnackbar } = useSnackbar();

    const itemConfig = item.template_config;
    const isHaveInfo = item.hasOwnProperty('thumbnail_image');

    const [thumbnail, setThumbnail] = useState<string>(sizeImageSrc[itemConfig.size]);
    const [isShowInfoPreviewModal, setIsShowInfoPreviewModal] = useState(false);
    const [isShowConfirmModal, setIsShowConfirmModal] = useState(false);

    useEffect(() => {
        const fetchThumbnail = async () => {
            if (isHaveInfo) {
                try {
                    const thumbImgSrc = await downloadFile(item.id, item.thumbnail_image, 'thumbnail');
                    if (thumbImgSrc) {
                        setThumbnail(thumbImgSrc);
                    }
                } catch (error) {
                    showSnackbar('', "error");
                }
            }
        };

        fetchThumbnail();
    }, []);

    const clickPreviewInfo = () => {
        setIsShowInfoPreviewModal(true);
    }

    const clickDeleteInfo = async () => {
        if (isArchived) return;

        setIsShowConfirmModal(true);
    }

    const handleCloseConfirmDeleteModal = async (confirm: boolean) => {
        setIsShowConfirmModal(false);
        if (!confirm) return;

        try {
            const infoId = item.id;
            await InfographicService.deleteInfo(mediaId, infoId);
            onDelete(infoId);
        } catch (error) {
            showSnackbar('', "error");
        }
    }

    const clickEditInfographic = () => {
        if (isArchived) return;

        navigate(`/infographic/edit/${mediaId}/${item.id}`);
    }

    const clickDownloadInfographic = async () => {
        try {
            const fullImageSrc = await downloadFile(item.id, item.full_image, 'full');
            saveAs(fullImageSrc, item.template_config.title + '.png');
        } catch (error) {
            showSnackbar('', "error");
        }
    }

    return (
        <>
            <div className="detail-content-item-info-list-control">
                <div className="detail-content-item-info-list-top-control">
                    <div className="detail-content-item-info-list-name">
                        {no}.
                        <div className="detail-content-item-info-name">{itemConfig.title}</div>&nbsp;
                        {!isHaveInfo && <span className="detail-content-item-info-draft">(แบบร่าง)</span>}
                    </div>

                    <div className="detail-content-item-info-top-right-control">
                        <Button
                            variant="text"
                            className="detail-content-item-info-top-right-preview-text"
                            disabled={!isHaveInfo}
                            onClick={clickPreviewInfo}
                        >
                            ดูตัวอย่าง
                        </Button>

                        <IconButton color="primary" onClick={clickDeleteInfo} disabled={isArchived}>
                            <img src={isArchived ? TRASH_DISABLED_ICON : TRASH_ICON} className="detail-content-item-info-top-right-preview-icon"></img>
                        </IconButton>
                    </div>
                </div>

                <div className="d-flex justify-content-between align-items-end">
                    <div className="ps-3">
                        <p className="detail-content-item-info-list-size">ขนาด {itemConfig.size}</p>
                        <img src={thumbnail} className="detail-content-item-info-list-image" />
                    </div>

                    <div className="detail-content-item-info-list-button-control">
                        <Button
                            variant="outlined"
                            className="detail-content-item-info-list-button"
                            onClick={clickEditInfographic}
                            disabled={isArchived}
                        >
                            แก้ไข Infographic
                        </Button>

                        <Button
                            variant="outlined"
                            className="detail-content-item-info-list-button mt-3"
                            onClick={clickDownloadInfographic}
                            disabled={!isHaveInfo}
                        >
                            ดาวน์โหลด
                        </Button>
                    </div>
                </div>
            </div>

            {
                isShowInfoPreviewModal && <InfographicPreviewModal show={isShowInfoPreviewModal} onClose={() => setIsShowInfoPreviewModal(false)} infoId={item.id} />
            }

            {
                isShowConfirmModal && <ConfirmModal show={isShowConfirmModal} type="delete" onClose={handleCloseConfirmDeleteModal} />
            }

            <CustomSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                duration={snackbar.duration}
                onClose={hideSnackbar}
            />
        </>
    )
}

export default InfographicItemComponent;